import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../PropTypes/StoreProptypes";
import { routesList } from "../Routes";
import ErrorPage from "../Pages/ErrorPage";
import ProtectedRoute from "../Routes/ProtectedRoute";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ThemeRouteController from "../Context/ThemeRouteController";

const navigationMap: Record<string, string> = {
  "accessibility-add-on-services": "addon-services/white-label-service",
  "manage-plan": "manage-plan",
  "orders": "orders",
  "widget-settings": "widget-settings",
  "integration-scripts": "scripts",
  "domain-report": "domain-report",
  "image-alt-text-remediation": "manage-image-alt-text",
  "my-websites": "websites",
  "accessibility-checker": "accessibility-checker"
};

function BrowserRouterComponents() {
  const user = useSelector((state: StoreProptypes) => state.user);
  const { websites } = useSelector((store: StoreProptypes) => store);

  // Memoize the routes so they recalc whenever websites/user change
  const finalRoutes = useMemo(() => {
    const currentWebsite = websites?.find((w) => w?.permissions);
    const finalWebSite = currentWebsite?.permissions.map((i: any) => i?.name) || [];

    const protectedRoutes = routesList?.filter((r) => !r.protected);

    let accessibleRoutes =
      finalWebSite?.length > 0
        ? routesList
            .map((route) => {
              if (route.protected) return route; // keep protected as is
              const matched = finalWebSite.find((w) =>
                route.path?.includes(navigationMap[w])
              );
              return matched ? route : null;
            })
            .filter((route): route is typeof route => route != null)
        : [];

    accessibleRoutes =
      finalWebSite?.length > 0 ? [...accessibleRoutes, ...protectedRoutes] : routesList;
    return accessibleRoutes;
  }, [websites]);

  return (
    <BrowserRouter>
      <ThemeRouteController/>
      <React.Suspense>
        <Routes>
          {finalRoutes.map((route) => (
            <Route
              key={route?.path}
              index={route?.path === "/"}
              path={route?.path}
              element={
                route?.protected ? (
                  <ProtectedRoute userid={user?.id || null}>{route?.element}</ProtectedRoute>
                ) : (
                  route?.element
                )
              }
            />
          ))}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default BrowserRouterComponents;
